import React from 'react'
import PropTypes from 'prop-types'
import { compose } from 'recompose'
import { connect } from 'react-redux'
import { DigitalRecipient } from '../components'
import { selectors } from '../reducer'
import * as actions from '../actions'
import { DigitalRecipientType } from 'types'

const propTypes = {
  giftMessage: PropTypes.string,
  recipientContact: DigitalRecipientType,
  setGiftMessage: PropTypes.func.isRequired,
  setRecipientContact: PropTypes.func.isRequired,
}

function Recipient({
  giftMessage = null,
  recipientContact = null,
  setGiftMessage,
  setRecipientContact,
}) {
  return (
    <DigitalRecipient
      {...{
        giftMessage,
        recipientContact,
        setGiftMessage,
        setRecipientContact,
      }}
    />
  )
}

function mapStateToProps(state) {
  return {
    giftMessage: selectors.giftMessage(state),
    recipientContact: selectors.recipientContact(state),
  }
}

const mapDispatchToProps = {
  setGiftMessage: actions.setGiftMessage,
  setRecipientContact: actions.setRecipientContact,
}

Recipient.propTypes = propTypes

export default compose(connect(mapStateToProps, mapDispatchToProps))(Recipient)
